import { de_GetPartnerBySubfolderCommand, se_GetPartnerBySubfolderCommand, } from "../protocols/Aws_restJson1";
import { getSerdePlugin } from "@smithy/middleware-serde";
import { Command as $Command } from "@smithy/smithy-client";
export { $Command };
export class GetPartnerBySubfolderCommand extends $Command.classBuilder()
    .m(function (Command, cs, config, o) {
    return [
        getSerdePlugin(config, this.serialize, this.deserialize),
    ];
})
    .s("Api", "GetPartnerBySubfolder", {})
    .n("ApiClient", "GetPartnerBySubfolderCommand")
    .f(void 0, void 0)
    .ser(se_GetPartnerBySubfolderCommand)
    .de(de_GetPartnerBySubfolderCommand)
    .build() {
}
